import request from "@/utils/request";

export function getUserPage(data) {
  return request({
    url: "/c/user/page",
    method: "get",
    params:data,
  });
}

export function addUser(data) {
  return request({
    url: "/c/user/add",
    method: "post",
    data:data,
  });
}
